module.exports = __webpack_public_path__ + "img/qrcode.e35efc39.png";